import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { EditDistributorComposer } from "@/forms/sensory"
import { useApiQuery } from "@/api/ApiQueryServiceProvider"
import { useToast } from "@/contexts/ToastContext"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { Truck, Loader2 } from "lucide-react"

function EditDistributorPage() {
  const { distributorNumber } = Route.useParams()
  const navigate = useNavigate()
  const { toast } = useToast()

  const { data, isLoading } = useApiQuery("getDeviceDistributor", { distributorNumber })
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const d = (data as any)?.content?.distributor

  const handleBack = () => navigate({ to: '/sensory/distributors' })

  if (isLoading) {
    return (
      <div className="p-6 flex items-center justify-center py-12">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    )
  }

  return (
    <div className="p-6 space-y-4">
      <Card className="shadow-sm pb-0 overflow-hidden">
        <CardHeader className="bg-slate-700 text-white [&_p]:text-slate-300 pb-6">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10">
              <Truck className="h-5 w-5 text-primary" />
            </div>
            <div>
              <CardTitle className="text-xl">Distributor</CardTitle>
              <CardDescription className="text-base">Update distributor details</CardDescription>
            </div>
          </div>
        </CardHeader>
      </Card>
      <Card className="shadow-sm">
        <CardContent className="pt-6">
          {d ? (
            <EditDistributorComposer
              distributorNumber={d.distributorNumber}
              initialValues={{
                distributorNumber: d.distributorNumber,
                distributorName: d.distributorName,
              }}
              submitLabel="Save Distributor"
              showHeader={false}
              onSuccess={handleBack}
              onError={(error) => toast({ title: 'Error', description: `Failed to update distributor: ${error.message}`, type: 'error' })}
              onCancel={handleBack}
            />
          ) : (
            <p className="text-sm text-muted-foreground">Distributor not found.</p>
          )}
        </CardContent>
      </Card>
    </div>
  )
}

export const Route = createFileRoute("/sensory/distributors/$distributorNumber_/edit")({
  staticData: {
    title: 'Edit Distributor',
    isSecured: true,
  },
  component: EditDistributorPage,
})
